import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { ShowFullArtistProfileRequest } from '@/features/work/api/show-full-artist-profile/request';
import { showFullArtistProfile } from '@/features/work/api/show-full-artist-profile/request';

export const useShowFullArtistProfileQuery = (
  params: ShowFullArtistProfileRequest,
  settings?: QuerySettings<typeof showFullArtistProfile>
) =>
  useQuery({
    queryKey: ['showFullArtistProfile', params.profileId],
    queryFn: () =>
      showFullArtistProfile({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
